<section class="subtitle-sect1">
  <span>
    {{ isAjustes ? 'Ajustes en documentos de subsidio y/o afiliación' : 'Detalle de solicitud' }}
  </span>
</section>
<section class="subtitle-sect2">
  <span>
    {{
    isAjustes
    ? 'Ajusta los documentos que presentan novedades'
    : 'Información sobre el estado de su solicitud'
    }}
  </span>
</section>
<div class="container">
  <section *ngIf="!isAjustes">
    <app-informacion></app-informacion>
  </section>

  <mat-card class="mat-elevation-z0">
    <div class="info-grid">
      <div class="info-column">
        <section class="title-column-custom">
          <span class="title-blue">Información de la solicitud</span>
        </section>
        <div class="field">
          <label>Radicado:</label>
          <p>{{ isAjustes ? (data?.code || 'No registrada') : solicitudDetalle?.radicado }}</p>
        </div>
        <div class="field">
          <label>Fecha de radicación:</label>
          <p> {{ (fechaCreacion | date:'dd/MM/yyyy h:mm a') || solicitudDetalle?.fechaRadicacion }}</p>
        </div>
        <div class="field">
          <label>Fecha de actualización:</label>
          <p>{{ (FechaActualizacion | date:'dd/MM/yyyy h:mm a') || solicitudDetalle?.fechaActualizacion }}</p>
        </div>
        <div class="field">
          <label>Estado:</label>
          <p> {{ obtenerNombreEstado(data?.state) }}</p>
        </div>
      </div>

      <div class="info-column">
        <section class="title-column-custom">
          <span class="title-blue">Información del titular</span>
        </section>

        <div class="field">
          <label>Nombre:</label>
          <p>{{ nombreTitularUI }}</p>
        </div>

        <div class="field">
          <label>Tipo de documento:</label>
          <p> {{ util.homologarTipoDocuTitular(titular.tipoDoc) }} </p>
        </div>
        <div class="field">
          <label>Número de documento:</label>
          <p> {{ isAjustes ? data?.numberDocument : solicitudDetalle?.numeroIdentidadTitular }}</p>
        </div>
      </div>
    </div>
  </mat-card>

  <div *ngIf="isAjustes" class="container-message-precaution">
    <p>
      <img src="assets/images/warning.png"> Tienes un <span style="font-weight: 700;"> plazo maximo de 5 dias </span>
      para
      cargar los documentos solicitados a continuación
    </p>
  </div>

  <mat-accordion>
    <ng-container *ngFor="let key of objectKeys(data?.documentos); let i = index">
      <mat-expansion-panel *ngIf="panelVisibility[i]" [expanded]="i === 0">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <label style="margin-left: 6px;"><strong>Documento:</strong></label>&nbsp;{{
            data?.documentos[key].documentos[0].documento.numeroIdentidadPropietarioDocumento }}
            -
            &nbsp;<strong>{{ obtenerTipoPersona(key) }}:  </strong>&nbsp;{{ data?.documentos[key].documentos[0].nombreCompleto }}
          </mat-panel-title>

        </mat-expansion-panel-header>
        <div class="row mt-masive" *ngIf="loadingTop">
          <div class="col-md-12 text-center">
            <div class="spinner-two spinner-two-blue"></div>
          </div>
        </div>

        <table aria-label="Tabla de histórico de afiliaciones" class="rwd-table" width="100%"
          cellpadding="0" cellspacing="0" id="tableAffiliation">
          <thead class="thead">
            <th scope="col" class="text-gray-category color-gray">
              Tipo complemento
            </th>
            <th scope="col" class="text-gray-category color-gray">
              Nombre/Archivo
            </th>

            <th scope="col" class="text-gray-category color-gray">
              Comentario
            </th>

            <th scope="col" class="text-gray-category color-gray">
              Fecha revision
            </th>

            <th scope="col" class="text-gray-category color-gray">
              Gestion
            </th>
          </thead>

          <tbody>

            <tr *ngIf="data?.documentos.length <= 0 && !loadingTop">
              <td colspan="5" style="text-align: center;">
                <span class="text-gray-category color-red">No hay documentos recientes</span>
              </td>
            </tr>

            <tr *ngFor="let documento of data?.documentos[key].documentos">
              <td data-th="tipo complemento">
                <div>
                  {{ documento?.documento.solicitudesComplementosEntity.solicitudesTipos.tipo }}
                </div>
              </td>

              <td data-th="nombre/archivo">
                <div class="texto-recortado">
                  <a [href]="getBlobUrl(documento?.documento.url)" target="_blank" rel="noopener noreferrer">
                    {{ documento?.documento.documentosDigitalesTipos.nombre }}
                  </a>
                </div>
              </td>

              <td data-th="comentario">
                <div>
                  {{ obtenerObservaciones(documento?.documento.observaciones) }}
                </div>
              </td>

              <td data-th="Fecha revision">
                <div>
                  {{ documento?.documento.fechaActualizacion | date:'dd/MM/yyyy h:mm a' }}
                </div>
              </td>

              <td data-th="Gestión" class="text-gray-category color-gray">
                <input type="file" #fileInput (change)="onFileSelected($event, documento, key, i)"
                  accept="application/pdf" style="display: none;" />

                <button *ngIf="!documento.selectedFile" (click)="fileInput.value = null; fileInput.click()"
                  class="u-btn u-btn--blue">
                  Seleccionar Archivo
                </button>

                <button *ngIf="documento?.selectedFile" (click)="removeFile(documento, fileInput, key, i)"
                  class="u-btn u-btn--red u-btn--delete">
                  Eliminar Archivo
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="steps-cont_actions d-flex justify-content-center container" style="margin-top: 35px;">
          <button role="button" appDebounceClick id="Afiliacion_PTEC-afiliar-trabajador-regresar"
            title="Enviar todos los documentos" (click)="enviarTodosDocumentos(i, key)"
            [disabled]="!allDocumentsUploaded[i]" class="u-btn u-btn--blue">
            Enviar
          </button>
        </div>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>

  <!-- Panel de Documentos: DETALLE -->
  <mat-accordion *ngIf="!isAjustes">
    <mat-expansion-panel *ngFor="let tipo of objectKeys(complementosAgrupados)">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ tipo }}</mat-panel-title>
      </mat-expansion-panel-header>
      <table class="rwd-table" width="100%">
        <thead class="thead">
          <tr>
            <th>Parentesco</th>
            <th>Número Documento</th>
            <th>Nombre</th>
            <th>Fecha de actualizacion</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let persona of complementosAgrupados[tipo]">
            <td>{{ persona.parentesco }}</td>
            <td>{{ persona.numeroDocumento }}</td>
            <td>{{ persona.nombre }}</td>
            <td>{{ persona.fechaActualizacion | date:'dd/MM/yyyy h:mm a' }}</td>
            <td>{{ obtenerNombreEstado(persona.estado) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="steps-cont_actions d-flex justify-content-center container">
        <button role="button" appDebounceClick id="btn-enviar-documentos-{{ i }}" title="Enviar todos los documentos"
          (click)="enviarTodosDocumentos(i, key)" [disabled]="!allDocumentsUploaded[i]" class="u-btn u-btn--blue">
          Enviar
        </button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <br>
  <div class="col-md-12">
    <div class="steps-cont_actions d-flex justify-content-center container">
      <a role="button" appDebounceClick title="Volver" href="javascript:history.back()"
        routerLinkActive="router-link-active" class="u-btn u-btn--line r-hide center-text">Volver</a>
    </div>
  </div>
</div>
